<template>
  <div class="cont-main">
    <div class="box-y-scroll p-r-5" :style="{ 'max-height': maxHeight }">
      <div class="cont-title">基本信息</div>
      <div class="cont-form">
        <e-form
          ref="refForm1"
          class="flex-1"
          :config="formConfig"
          :column="formColumn1"
          :data.sync="detailData.pact_bill"
          :disabled="isSelfDisabled"
        />
        <e-form
          ref="refForm2"
          class="flex-1"
          :config="formConfig"
          :column="formColumn2"
          :data.sync="detailData.pact_bill"
          :disabled="isSelfDisabled"
        />
      </div>

      <div class="cont-title m-t-10">
        <div>
          兹经甲乙协商同意，出需方(乙方)购进，供方(甲方)售出下列货物，并就本次交易达成如下合同，共同遵守执行
        </div>
        <el-button size="mini" type="primary" @click="jumbVerify">编辑商品</el-button>
      </div>
      <!-- 表格 -->
      <vxe-grid
        ref="refTable"
        size="mini"
        show-footer
        :min-height="42"
        :columns="tableColumn"
        :data="detailData.stock_list"
        :keyboard-config="{ isArrow: true }"
        :footer-method="footerMethod"
        :disabled="isSelfDisabled"
      >
        <!-- slot_default -->
        <template #default_pact_remark="{ row }">
          <el-input v-model="row.pact_remark" size="mini" :disabled="isSelfDisabled" />
        </template>
      </vxe-grid>

      <e-form
        ref="refForm3"
        class="m-t-10"
        :config="formConfig"
        :column="formColumn3"
        :data.sync="detailData.pact_bill"
        :disabled="isSelfDisabled"
      />

      <div class="cont-title m-t-10">签名盖章</div>
      <div class="cont-form">
        <div class="flex-1">
          <div class="flex f-s-12 m-b-5 m-l-15">
            <span class="f-bold m-r-10 p-y-5">甲方代表签名盖章</span>
            <el-select size="mini" v-model="detailData.pact_bill.yin_zhang_img" disabled>
              <el-option
                v-for="(item, index) in sealList"
                :key="index"
                :label="item.key"
                :value="item.val"
                :disabled="item.disabled"
              />
            </el-select>
            <el-link
              v-if="detailData.pact_bill.yin_zhang_img && detailData.pact_bill.status > 1"
              type="primary"
              class="m-l-10"
              style="height: 20px; margin-top: 4px"
              @click.native="$util.windowOpenImg(detailData.pact_bill.yin_zhang_img)"
            >
              查看公章
            </el-link>
          </div>
          <e-form
            ref="refForm4"
            class="flex-1"
            :config="formConfig"
            :column="formColumn4"
            :data.sync="detailData.pact_bill"
            :disabled="isSelfDisabled"
          />
        </div>
        <div class="flex-1">
          <div class="flex f-s-12 m-b-5 m-l-15">
            <span class="f-bold m-r-10 p-y-5">乙方代表签名盖章</span>
          </div>
          <e-form
            ref="refForm5"
            class="flex-1"
            :config="formConfig"
            :column="formColumn5"
            :data.sync="detailData.pact_bill"
            :disabled="isSelfDisabled"
          />
        </div>
      </div>

      <div class="cont-title m-t-10">上传已签约合同文件</div>
      <e-upload-image
        v-if="detailData.pact_bill.pack_photo_list"
        :list.sync="detailData.pact_bill.pack_photo_list"
        :disabled="isSelfDisabled"
        isDelete
      />
    </div>

    <div class="flex flex-x-end m-t-10">
      <el-button v-if="!isSelfDisabled" type="primary" size="mini" @click="detailSave(true)">
        保存合同
      </el-button>
      <el-button v-if="!isSelfDisabled" type="success" size="mini" @click="detailPush">
        提交审核
      </el-button>
      <el-button v-if="id && isChuangJian" type="default" size="mini" @click="detailPrint">
        打印合同
      </el-button>
    </div>

    <!-- 弹窗-增改客户 isLockSaler -->
    <b-popup-customer
      v-if="isShowPopupCustomer"
      :show.sync="isShowPopupCustomer"
      :id="activeCustomerId"
      :salerId="detailData.pact_bill.saler_id"
      :salerName="detailData.pact_bill.saler_name"
      :isLockJieDaiStatus="!activeCustomerId"
      @success="customerUpdate"
    />
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    isChuangJian: {
      type: Boolean,
      refault: false
    },
    isFuZe: {
      type: Boolean,
      refault: false
    }
  },
  data() {
    return {
      isDetailPrint: false,
      kaiDanList: [],
      customerList: [],
      sealList: [],
      detailData: {
        pact_bill: {
          saler: '',
          saler_id: '',
          saler_name: '',
          buyer: '',
          buyer_phone: '',
          buyer_address: '',
          pact_time: ''
        },
        stock_list: []
      },
      customerKeyword: '',
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn1: [
        {
          type: 'text',
          title: '合同编码',
          field: 'bill_code',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'select',
          title: '供方(甲方)',
          field: 'saler_company_name',
          options: [],
          fnChange: () => {
            this.kaiDanChoose()
          }
        },
        {
          type: 'text',
          title: '甲方联系人',
          field: 'saler_name',
          disabled: true
        },
        {
          type: 'number',
          title: '甲方手机号',
          field: 'saler_phone',
          disabled: true
        },
        {
          type: 'text',
          title: '甲方地址',
          field: 'saler_address',
          disabled: true
        }
      ],
      formColumn2: [
        {
          type: 'date',
          title: '签约日期',
          field: 'pact_time',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'select',
          title: '需方(乙方)',
          field: 'buyer_company_id',
          hide: false,
          options: [],
          optionDo: { title: '编辑', fn: () => {} },
          emptyDo: { title: '新增客户', fn: () => {} },
          filterable: true,
          remote: true,
          remoteMethod: (val) => {
            this.customerKeyword = val
            this.getCustomerList(true)
          },
          fnChange: () => {
            setTimeout(() => {
              this.customerChoose()
            }, 200)
          }
        },
        {
          type: 'text',
          title: '乙方联系人',
          field: 'buyer',
          disabled: true
        },
        {
          type: 'number',
          title: '乙方手机号',
          field: 'buyer_phone',
          disabled: true
        },
        {
          type: 'text',
          title: '乙方地址',
          field: 'buyer_address',
          disabled: true
        }
      ],
      formColumn3: [
        {
          type: 'text',
          title: '一、包装方式',
          field: 'package_type',
          placeholder: '包装方式'
        },
        {
          type: 'text',
          title: '二、合同履行地',
          field: 'pact_action_address',
          placeholder: '合同履行地'
        },
        {
          type: 'text',
          title: '三、运输方式',
          field: 'transport',
          placeholder: '运输方式'
        },
        {
          type: 'text',
          title: '四、付款方式',
          field: 'pay',
          placeholder: '付款方式'
        },
        {
          type: 'text',
          title: '五、产品执行标准',
          field: 'quality_action',
          placeholder: '产品执行标准'
        },
        {
          type: 'text',
          title: '六、产品验收标准',
          field: 'quality_check',
          placeholder: '产品验收标准'
        },
        {
          type: 'text',
          title: '七、违约责任',
          field: 'break_pact',
          placeholder: '违约责任'
        },
        {
          type: 'text',
          title: '八、争议解决',
          field: 'dispute_resolution',
          placeholder: '争议解决'
        },
        {
          type: 'text',
          title: '九、合同生效说明',
          field: 'pact_effect',
          placeholder: '合同生效说明'
        }
      ],
      formColumn4: [
        {
          type: 'text',
          title: '供方单位(甲方)',
          field: 'saler_company_name',
          disabled: true
        },
        {
          type: 'text',
          title: '甲方地址',
          field: 'saler_address',
          disabled: true
        },
        {
          type: 'text',
          title: '甲方代表',
          field: 'saler_name',
          disabled: true
        },
        {
          type: 'text',
          title: '开户银行',
          field: 'saler_bank_name',
          disabled: true
        },
        {
          type: 'text',
          title: '银行账号',
          field: 'saler_bank_code',
          disabled: true
        },
        {
          type: 'text',
          title: '统一社会信用代码',
          field: 'saler_tax_code',
          disabled: true
        }
      ],
      formColumn5: [
        {
          type: 'text',
          title: '需方单位(乙方)',
          field: 'buyer_company_name',
          disabled: true
        },
        {
          type: 'text',
          title: '乙方地址',
          field: 'buyer_address',
          disabled: true
        },
        {
          type: 'text',
          title: '乙方代表',
          field: 'buyer_name',
          disabled: true
        },
        {
          type: 'text',
          title: '开户银行',
          field: 'buyer_bank_name',
          disabled: true
        },
        {
          type: 'text',
          title: '银行账号',
          field: 'buyer_bank_code',
          disabled: true
        },
        {
          type: 'text',
          title: '统一社会信用代码',
          field: 'buyer_tax_code',
          disabled: true
        }
      ],
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '商品名称',
          field: 'name'
        },
        {
          title: '规格(mm)',
          field: 'spec'
        },
        {
          title: '单位',
          field: 'unit'
        },
        {
          title: '数量',
          field: 'counts'
        },
        {
          title: '单价(元)',
          field: 'sales_price'
        },
        {
          title: '金额(元)',
          field: 'sales_amount'
        },
        {
          title: '备注',
          slots: { default: 'default_pact_remark' },
          editRender: { autofocus: '.el-input__inner' }
        }
      ],
      isShowPopupCustomer: false,
      activeCustomerId: null
    }
  },
  computed: {
    maxHeight() {
      let result = `${this.$util.getViewHeight() - 278}px`
      return result
    },
    selfAccountData() {
      let result = this.$store.getters.getLoginAccount
      return result
    },
    isSelfDisabled() {
      let result = !(
        (this.detailData.pact_bill.status_str === '' ||
          this.detailData.pact_bill.status_str === '暂存' ||
          this.detailData.pact_bill.status_str === '已驳回') &&
        this.isChuangJian &&
        this.detailData.pact_bill.bill_id
      )
      return result
    }
  },
  mounted() {
    // 初始化-新增客户
    this.formColumn2.forEach((item) => {
      if (item.field === 'buyer_company_id') {
        item.optionDo.fn = this.customerEdit
        item.emptyDo.fn = this.customerAdd
      }
    })

    if (this.id) {
      this.getDetailData()
    } else {
      this.getInitData()
    }
    this.getKaiDanList()
    this.getSealListData()
  },
  methods: {
    // 跳转到核算单
    jumbVerify() {
      if (this.id) this.detailSave()
      this.$emit('jump', 'Verify')
    },
    // 获取-详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/pack2/detail',
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.detailData = this.$util.deepCopy(res.data)
          this.getCustomerList()
        }
      })
    },
    // 获取-初始数据
    getInitData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/pack2/chuShiHuaHeTong'
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result1 = this.$util.deepCopy(res.data.pact_bill)
          let result2 = {
            saler: this.selfAccountData.nick_name,
            saler_name: this.selfAccountData.nick_name,
            saler_id: this.selfAccountData.id,
            saler_phone: this.selfAccountData.user_name
          }
          this.detailData.pact_bill = { ...this.detailData.pact_bill, ...result1, ...result2 }
          this.getCustomerList()
        }
      })
    },
    // 获取-开单列表
    getKaiDanList() {
      this.$api({
        method: 'get',
        url: '/admin/billingCompany/search'
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.page.list.map((item) => {
            return {
              key: item.name,
              val: item.name,
              data: this.$util.deepCopy(item)
            }
          })
          this.kaiDanList = result
          this.formColumn1.forEach((itemColumn) => {
            if (itemColumn.field === 'saler_company_name') {
              itemColumn.options = this.$util.deepCopy(result)
            }
          })
        }
      })
    },
    // 开单-选择
    kaiDanChoose() {
      this.kaiDanList.forEach((item) => {
        if (item.val === this.detailData.pact_bill.saler_company_name) {
          this.detailData.pact_bill.saler_address = item.data.address
          this.detailData.pact_bill.saler_bank_name = item.data.bank_name
          this.detailData.pact_bill.saler_bank_code = item.data.bank_code
          this.detailData.pact_bill.saler_tax_code = item.data.tax_code
        }
      })
    },
    // 获取-客户列表
    getCustomerList(isFilter = false) {
      this.formColumn2.forEach((itemColumn) => {
        if (itemColumn.field === 'buyer_company_id') {
          if (!isFilter) itemColumn.hide = true
          let filterData = {
            // saler_id: this.detailData.pact_bill.saler_id
          }
          let id = this.detailData.pact_bill.buyer_company_id
          if (id) {
            this.customerKeyword = ''
            filterData.id = id
          }
          this.$api({
            method: 'post',
            url: '/admin/customers/search',
            data: {
              keyword: this.customerKeyword,
              filterData,
              sortData: {
                last_gen_jin_date: 'desc'
              },
              pageSize: 200
            }
          }).then((res) => {
            if (res.data.state === 'ok') {
              let result = res.data.page.list.map((item) => {
                return {
                  key: item.customer_name,
                  val: item.id,
                  data: this.$util.deepCopy(item)
                }
              })
              this.customerList = result
              itemColumn.options = this.$util.deepCopy(result)
              if (!isFilter) itemColumn.hide = false
            }
          })
        }
      })
    },
    // 客户新增
    customerAdd() {
      let refForm2 = this.$refs.refForm2
      refForm2.$refs.buyer_company_id[0].blur()
      this.activeCustomerId = null
      this.isShowPopupCustomer = true
    },
    // 客户编辑
    customerEdit(data) {
      this.activeCustomerId = data.val
      this.isShowPopupCustomer = true
    },
    // 客户更新
    customerUpdate(val) {
      this.detailData.pact_bill.buyer_company_id = val.id
      this.detailData.pact_bill.buyer_company_uuid = val.company_uuid

      this.detailData.pact_bill.buyer = val.linkman
      this.detailData.pact_bill.buyer_phone = val.phone
      this.detailData.pact_bill.buyer_address = val.address

      this.detailData.pact_bill.buyer_company_name = val.customer_name
      this.detailData.pact_bill.buyer_name = val.linkman
      this.detailData.pact_bill.buyer_bank_name = val.deposit_bank
      this.detailData.pact_bill.buyer_bank_code = val.deposit_bank_number
      this.detailData.pact_bill.buyer_tax_code = val.tax_id
      this.getCustomerList()
    },
    // 客户选择
    customerChoose() {
      let id = this.detailData.pact_bill.buyer_company_id
      if (id) {
        this.customerList.forEach((item) => {
          if (item.val === id) {
            this.detailData.pact_bill.buyer = item.data.linkman
            this.detailData.pact_bill.buyer_phone = item.data.phone
            this.detailData.pact_bill.buyer_address = item.data.address

            this.detailData.pact_bill.buyer_company_name = item.data.customer_name
            this.detailData.pact_bill.buyer_name = item.data.linkman
            this.detailData.pact_bill.buyer_bank_name = item.data.deposit_bank
            this.detailData.pact_bill.buyer_bank_code = item.data.deposit_bank_number
            this.detailData.pact_bill.buyer_tax_code = item.data.tax_id
          }
        })
      } else {
        this.detailData.pact_bill.buyer_company_name = ''
        this.detailData.pact_bill.buyer_company_uuid = ''
      }
      this.getCustomerList()
    },
    // 获取印章数据列表
    getSealListData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/yinZhang/search',
        data: {
          keyword: this.keyword,
          sortData: {
            id: 'asc'
          }
        }
      }).then((res) => {
        if (res.status === 200) {
          this.sealList = res.data.list.map((item) => {
            let obj = {
              key: item.name,
              val: item.tu_pian.length ? item.tu_pian[0].url : '',
              disabled: !item.is_open
            }
            return obj
          })
        }
      })
    },
    // 表格底部
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'sales_amount'].includes(column.field)) {
            return this.$util.listFieldTotal(data, column.field)
          }
        })
      ]
    },
    // 详情-提交审核
    detailPush() {
      if (!this.id) {
        this.$message.error('请先编辑商品')
        return
      }
      this.$confirm('提交审核后，需前往订单列表进行管理！', '提示', {
        confirmButtonText: '确认提交',
        cancelButtonText: '放弃'
      })
        .then(() => {
          this.detailPushConfirm()
        })
        .catch(() => {})
    },
    // 详情-提交审核-确认
    detailPushConfirm() {
      this.detailSave()
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/salerDoAudit',
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已生成合同')
          this.popupCancel()
        }
      })
    },
    // 详情-保存
    detailSave(isPrompt) {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/pack2/saveOrUpdate',
        data: this.detailData
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$emit('update:id', res.data.pact_bill.bill_id)
          if (isPrompt) this.$message.success('操作成功')
          if (this.isDetailPrint) {
            this.isDetailPrint = false
            this.detailPrintConfirm()
            return
          }
        }
      })
    },
    // 详情-打印
    detailPrint() {
      if (this.isSelfDisabled) {
        this.detailPrintConfirm(this.id)
      } else {
        this.isDetailPrint = true
        this.detailSave()
      }
    },
    // 详情-打印-确认
    detailPrintConfirm() {
      window.open(`/new/verify/print/contract?id=${this.id}`, '_blank')
    },
    // 弹窗取消
    popupCancel() {
      this.$emit('success')
    }
  }
}
</script>

<style lang="less" scoped>
.cont-main {
  .cont-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 24px;
    font-weight: bold;
    font-size: 12px;
    border-bottom: 1px solid @colorGrayD;
    margin-bottom: 5px;
  }
  .cont-form {
    display: flex;
    margin-top: 5px;
  }
  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
  /deep/ .el-form-item__label {
    line-height: 24px;
  }
  /deep/ .el-form-item__content {
    height: 24px;
    line-height: 24px;
  }
  /deep/ .el-input__inner {
    height: 24px;
    line-height: 24px;
  }
  /deep/ .el-input__icon {
    line-height: 24px;
  }
}
</style>
